import React from 'react';

export const bookingView = {
  complete: 'complete',
  appointment: 'appointment',
};

export const BookingContext = React.createContext(bookingView.complete);

export const bookingClassNameModifier = (context) => {
  switch (context) {
    case bookingView.appointment:
      return 'Appointment';
    default:
      return '';
  }
};
